import { tv } from "tailwind-variants";

export const contentCard = tv({
    slots: {
        base: "",
        image: "tw:hover:opacity-80 tw:hover:transition-opacity tw:hover:duration-220 tw:hover:ease-in-out"
    }
});
